import { SelectItem } from "@/components/ui/select";
import { TICKET_STATUS_DROPDOWN_OPTIONS } from "@sd/constants/ticketStatuses";

type StatusOption = { value: string; label: string };

export function TicketStatusSelectItems({
  includeAll = false,
  options = TICKET_STATUS_DROPDOWN_OPTIONS,
}: {
  includeAll?: boolean;
  /** Override the default full workflow list (e.g. Agent-only change statuses). */
  options?: readonly StatusOption[];
}) {
  return (
    <>
      {includeAll ? <SelectItem value="all">All Status</SelectItem> : null}
      {options.map(opt => (
        <SelectItem key={opt.value} value={opt.value}>
          {opt.label}
        </SelectItem>
      ))}
    </>
  );
}
